import { render, staticRenderFns } from "./PodrucjeTemeDetails.vue?vue&type=template&id=f7899f82&scoped=true&"
import script from "./PodrucjeTemeDetails.vue?vue&type=script&lang=js&"
export * from "./PodrucjeTemeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7899f82",
  null
  
)

export default component.exports